import React  from 'react';
import { Trans } from '@lingui/macro';
import { Badge } from 'antd';
import { Link, useHistory, useLocation } from 'react-router-dom';
import useSelector from '../../../util/hooks/useSelector';
import { calcDestinationStateList } from '../constants';
import { TopBarCart } from '../../../components/icons/TopBarCart';

type Props = {
  isGlobalMenuShown: boolean
}

function CartIndicator({
  isGlobalMenuShown
}: Props) {
  const { destinations } = useSelector((state) => state.cart);
  const history = useHistory();
  const location = useLocation();

  const calcDestinations = React.useMemo(() => destinations.filter((_) => calcDestinationStateList.includes(_.status)), [destinations]);

  const handleClick = React.useCallback((e: React.MouseEvent) => {
    if (location.pathname === '/cart') {
      e.preventDefault();
      history.replace('/cart');
      window.location.reload();
    }
  }, [location.pathname, history]);

  return (
    <>
      <Link title="Корзина" className="gx-d-flex gx-align-items-center gx-position-relative custom-navbar__menu-item gx-text-nowrap" to="/cart" onClick={handleClick}>
        <Badge status={calcDestinations.length ? 'error' : undefined}>
          <TopBarCart/>
        </Badge>
        {
          isGlobalMenuShown ? null : <><Trans>Корзина</Trans> {!!calcDestinations.length && `(${calcDestinations.length})`}</>
        }
      </Link>
    </>
  );
}

export default CartIndicator;
